import React from "react";
import key_7 from "../assets/111.png";
import Header from "./Header";
import icon_a from "../assets/check.png";
import additional from "../assets/additional.png";
import king1 from "../assets/king-of-jungle/king/1.png";
import king2 from "../assets/king-of-jungle/king/2.png";
import king3 from "../assets/king-of-jungle/king/3.png";
import king4 from "../assets/king-of-jungle/king/4.png";
import kingkong1 from "../assets/king-of-jungle/1.png";
import kingkong2 from "../assets/king-of-jungle/2.png";
import kingkong4 from "../assets/king-of-jungle/4.png";

const KingOfTheJungle = () => {
  const images = [
  {
    src: king1,
    alt: "King Of The Jungle Slot Machine Reel Theme",
    title: "King Of The Jungle Slot Machine Reel Theme"
  },
  {
    src: king2,
    alt: "King Of The Jungle Slot Machine Buy Free Spin",
    title: "King Of The Jungle Slot Machine Buy Free Spin"
  },
  {
    src: king3,
    alt: "King Of The Jungle Slot Machine Super Win",
    title: "King Of The Jungle Slot Machine Super Win"
  },
  {
    src: king4,
    alt: "King Of The Jungle Slot Machine Free Spin Winning Price",
    title: "King Of The Jungle Slot Machine Free Spin Winning Price"
  }
];
  return (
    <div>
      <Header />

      {/* Intro Section */}
      <section className="bg-white py-10 px-4 md:px-10 lg:px-16 xl:px-48 mx-auto">
        <h2 className="text-3xl md:text-4xl text-left font-extrabold py-2">
          <span className="poppins-font ">King of the Jungle</span>
        </h2>
        <hr className="w-14 bg-black h-[2px] border-none shadow-lg mb-7 hidden sm:block" />
        <p className="text-gray-500 font-medium text-lg poppins-font2 text-start leading-relaxed">
          Step into the wild and take on the mighty challenge of the King of the Jungle Slots! This thrilling 5x3 reel slot game immerses you in the heart of the jungle, where fierce animals and massive wins await. With action-packed features like the Brawl Feature, Sticky Wilds, and the formidable Kong, every spin brings you closer to claiming the title of the true king!
        </p>
      </section>

      {/* Main Game Features */}
      <div className="container mx-auto px-4 md:px-10 lg:px-16 xl:px-48 py-16 flex flex-col lg:flex-row items-center justify-between gap-8">
        <div className="lg:w-1/2 text-center">
          <img src={kingkong1} alt="King Of The Jungle Slot Main Game Features" title="King Of The Jungle Slot Main Game Features" className="max-w-full h-auto" />
        </div>

        <div className="lg:w-1/2 text-start">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4 poppins-font">Main Game Features</h2>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed mb-4">
            <span className="font-bold text-gray-700">Brawl Feature:</span> When both the Boy and Girl symbols land on the reels at the same time, the Brawl Feature activates. Watch as the characters face off in a thrilling duel, where the victor transforms the losing symbol into the winning one—boosting your chances of hitting a big win. Plus, a random multiplier (x2 to x5) may be applied to the expanded reels, amplifying your payout!
          </p>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed">
            <span className="font-bold text-gray-700">Kong’s Sticky Wilds:</span> The legendary Kong symbol acts as a Sticky Wild, staying on the reels for multiple spins. This increases your chances of forming winning combinations and makes Kong an essential ally in your quest for jungle dominance.
          </p>
        </div>
      </div>

      {/* Free Game Features */}
      <div className="container mx-auto px-4 md:px-10 lg:px-16 xl:px-48 py-16 flex flex-col-reverse lg:flex-row items-center justify-between gap-8">
        <div className="lg:w-1/2 text-start">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4 poppins-font">Free Game Features: <span className="text-[#FF5300]">King of the Jungle</span></h2>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed mb-4">
            <span className="font-bold text-gray-700">Brawl Feature:</span> Just like in the Main Game, the Boy and Girl duel it out. The victorious character transforms the losing symbol into a matching one, and a random multiplier boosts your payout.
          </p>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed">
            <span className="font-bold text-gray-700">Kong’s Sticky Wilds:</span> Kong’s power doesn’t fade—he continues to stick around, helping you secure big wins throughout the Free Game.
          </p>
        </div>

        <div className="lg:w-1/2 text-center">
          <img src={kingkong2} alt="King Of The Jungle Slot Free Main Game Features" title="King Of The Jungle Slot Free Main Game Features" className="max-w-full h-auto" />
        </div>
      </div>

      {/* Additional Features */}
      <div className="container mx-auto px-4 md:px-10 lg:px-16 xl:px-48 py-16 flex flex-col lg:flex-row-reverse items-center justify-between gap-8">
        <div className="lg:w-1/2 text-center">
          <img src={additional} alt="Grand Jackpot" title="Grand Jackpot" className="max-w-full h-auto" />
        </div>

        <div className="lg:w-1/2 text-start">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4 poppins-font">Additional Features</h2>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed mb-4">
            King of the Jungle is not just about action-packed gameplay—it also offers rewarding bonus features:
          </p>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed">
            <span className="font-bold text-gray-700">Link Jackpot:</span> Connect with other players to compete for a shared jackpot prize.
          </p>
          <p className="text-gray-500 poppins-font2 text-base leading-relaxed">
            <span className="font-bold text-gray-700">Progressive Jackpot:</span> Every spin contributes to the jackpot, creating the potential for life-changing rewards.
          </p>
        </div>
      </div>

      {/* Why Play Section */}
      <div className="bg-white py-20 px-4 md:px-10 lg:px-16 xl:px-48">
        <div className="flex flex-col lg:flex-row-reverse gap-16">
          <div className="lg:w-1/2 flex justify-center">
            <img src={kingkong4} alt="King Of The Jungle Slot Game and Mega Win Jackpot Features" title="King Of The Jungle Slot Game and Mega Win Jackpot Features"
            className=" w-full max-w-md object-contain" />
          </div>

          <div className="lg:w-1/2">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-black text-start">
              Why Play King of the Jungle?
            </h2>

            <div className="space-y-6">
              {[
                { title: "Brawl Feature", text: "The Brawl Feature keeps the gameplay dynamic and engaging, giving you an edge with every battle." },
                { title: "Sticky Wilds", text: "Kong’s Sticky Wilds increase the chances of hitting winning combinations, giving you a strategic advantage." },
                { title: "Random Multipliers", text: "With multipliers ranging from x2 to x5, every spin could lead to massive payouts." },
                { title: "Immersive Jungle Theme", text: "Enjoy vibrant jungle graphics, realistic sound effects, and thrilling animations that put you right in the middle of the wild." },
              ].map((item, idx) => (  
                <div key={idx}>
                  <div className="flex items-center mb-2">
                    <img src={icon_a} alt="" className="w-6 h-6 mr-2" />
                    <h3 className="text-xl font-semibold text-black poppins-font">{item.title}:</h3>
                  </div>
                  <p className="text-gray-500 poppins-font2 text-start text-base leading-relaxed">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Gallery */}
  <div className="bg-gray-100 py-20">
  <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 px-4 md:px-10 xl:px-48">
    {images.map((item, idx) => (
      <div key={idx} className="bg-white rounded-lg shadow-md">
        <img
          src={item.src}
          alt={item.alt}
          title={item.title}
          className="w-full rounded-md"
        />
      </div>
    ))}
  </div>
</div>

      {/* Youtube Section */}
      <div className="bg-white py-20">
        <div className="container mx-auto px-4 md:px-10 xl:px-48">
          <h2 className="text-start font-semibold text-2xl poppins-font">Games</h2>
          <hr className="w-14 bg-black h-[2px] border-none shadow-lg my-4 hidden sm:block" />
          <div className="aspect-video w-full">
            <iframe
              src="https://www.youtube.com/embed/YOUR_YOUTUBE_VIDEO_ID"
              title="Skyriser Fireball Unleashed"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Game List */}
      <div className="bg-white py-20">
        <div className="container mx-auto px-4 md:px-10 xl:px-48 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-8">
          {["Fruit Juice", "King of the Jungle", "Urban Fighter", "Fruit Juice", "Fruit Juice", "Fruit Juice", "Fruit Juice"].map((name, idx) => (
            <div key={idx} className="text-center">
              <img src={key_7} alt={`Game ${idx}`} className="w-36 h-36 mx-auto mb-4" />
              <p className="text-lg font-bold text-gray-500 poppins-font">{name}</p>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default KingOfTheJungle;
